/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ event: NonNullable<unknown> }} Push_Match_End_BodyInputs */

const th_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`จบการแข่งขันที่ ${i?.event}`)
};

const en_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Full time at ${i?.event}`)
};

const ja_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} で試合終了`)
};

const zh_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 比赛结束`)
};

const es_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Final del partido en ${i?.event}`)
};

const pt_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fim de jogo em ${i?.event}`)
};

const id_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selesai di ${i?.event}`)
};

const fr_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fin du match à ${i?.event}`)
};

const tl_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tapos na sa ${i?.event}`)
};

const vi_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đã kết thúc tại ${i?.event}`)
};

const ko_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}에서 경기 종료`)
};

const de_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Spielende bei ${i?.event}`)
};

const ru_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Матч завершён на ${i?.event}`)
};

const tr_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} etkinliğinde maç bitti`)
};

const it_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Partita finita a ${i?.event}`)
};

const pl_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Koniec meczu na ${i?.event}`)
};

const uk_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Матч завершено на ${i?.event}`)
};

const hi_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} में मैच समाप्त`)
};

const ar_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`انتهت المباراة في ${i?.event}`)
};

const ms_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perlawanan tamat di ${i?.event}`)
};

const bn_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}-এ খেলা শেষ`)
};

const zh_tw2_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 比賽結束`)
};

const zh_hk2_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 比賽結束`)
};

const ur_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} میں میچ ختم`)
};

const fa_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`پایان بازی در ${i?.event}`)
};

const sw_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mchezo umeisha ${i?.event}`)
};

const nl_push_match_end_body = /** @type {(inputs: Push_Match_End_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wedstrijd afgelopen bij ${i?.event}`)
};

/**
* | output |
* | --- |
* | "Full time at {event}" |
*
* @param {Push_Match_End_BodyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_match_end_body = /** @type {((inputs: Push_Match_End_BodyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Match_End_BodyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_match_end_body(inputs)
	if (locale === "ja") return ja_push_match_end_body(inputs)
	if (locale === "zh") return zh_push_match_end_body(inputs)
	if (locale === "es") return es_push_match_end_body(inputs)
	if (locale === "pt") return pt_push_match_end_body(inputs)
	if (locale === "id") return id_push_match_end_body(inputs)
	if (locale === "fr") return fr_push_match_end_body(inputs)
	if (locale === "tl") return tl_push_match_end_body(inputs)
	if (locale === "vi") return vi_push_match_end_body(inputs)
	if (locale === "ko") return ko_push_match_end_body(inputs)
	if (locale === "de") return de_push_match_end_body(inputs)
	if (locale === "ru") return ru_push_match_end_body(inputs)
	if (locale === "tr") return tr_push_match_end_body(inputs)
	if (locale === "it") return it_push_match_end_body(inputs)
	if (locale === "pl") return pl_push_match_end_body(inputs)
	if (locale === "uk") return uk_push_match_end_body(inputs)
	if (locale === "hi") return hi_push_match_end_body(inputs)
	if (locale === "ar") return ar_push_match_end_body(inputs)
	if (locale === "ms") return ms_push_match_end_body(inputs)
	if (locale === "bn") return bn_push_match_end_body(inputs)
	if (locale === "zh-TW") return zh_tw2_push_match_end_body(inputs)
	if (locale === "zh-HK") return zh_hk2_push_match_end_body(inputs)
	if (locale === "ur") return ur_push_match_end_body(inputs)
	if (locale === "fa") return fa_push_match_end_body(inputs)
	if (locale === "sw") return sw_push_match_end_body(inputs)
	if (locale === "nl") return nl_push_match_end_body(inputs)
	return en_push_match_end_body(inputs)
});